import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import routes from "../routes";

import config from "../config.json";

import NotFound from "../views/NotFound";

const FirstRoute = () => {
  return <Redirect to={config.mainRoute} />;
};

let getRoutes = (routes) => {
  routes = routes.map((r) => {
    if (r.layout === "/admin")
      return <Route path={r.path} exact component={r.component} key={r.path} />;
    return null;
  });

  routes.push(<Route key="reroute" path={"/"} exact component={FirstRoute} />);

  routes.push(<Route key="404" component={NotFound} />);

  return routes;
};

let generateRoutes = <Switch>{getRoutes(routes)}</Switch>;

export default generateRoutes;
